import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "conditional"];
  static values = {
    show: Array,
  };

  connect() {
    this.toggle();
  }

  change() {
    this.toggle();
  }

  toggle() {
    const selected = this.selectTarget.value;
    const shouldShow = this.showValue.includes(selected);

    this.conditionalTargets.forEach((el) => {
      el.classList.toggle("d-none", !shouldShow);
    });
  }
}
